import initSharedPromotion from '@resources/js/components/promotion/initSharedPromotion'
import { getBcomOrExpediaPartnerType } from '@resources/js/components/promotion/helpers/getPartnerType'
import inViewport from '@resources/js/helpers/inViewport'
import MapView from '@resources/js/maps/MapView'
import MapHotelsStore from '@resources/js/maps/MapStores/MapHotelsStore'

import FormView from '@resources/js/components/form/FormView'
import FormStore from '@resources/js/components/form/FormStore'
import { syncFormStoreWithSession } from '@resources/js/components/form/formStoreSync'
import FormPresenter from '@resources/js/components/form/FormPresenter'
import handleCalendarFormSubmit from '@resources/js/helpers/handleCalendarFormSubmit'
import '@resources/js/analytics'

const partnerType = getBcomOrExpediaPartnerType()

initSharedPromotion()

// map
inViewport('#mapbox', () => {
	const map = new MapView({ zoom: 12 })
	const mapHotelsStore = new MapHotelsStore()
	const data = mapHotelsStore.getData()
	map.addMarkers(data)
	map.fitByCoords(mapHotelsStore.getCoordinates())
})

// спільний стор для форм
const formsStore = new FormStore()
syncFormStoreWithSession(formsStore)

// main form
const mainFormElement = document.querySelector('.js-form')
const mainFormView = new FormView(mainFormElement)
const mainFormPresenter = new FormPresenter(mainFormView, formsStore)

// side form
const sideFormCalendarConfig = {
	showMonths: 1,
	position: 'auto center',
}

const sideFormElement = document.querySelector('.js-side-form')
const sideFormView = new FormView(sideFormElement, {
	calendarConfig: sideFormCalendarConfig,
})
const sideFormPresenter = new FormPresenter(sideFormView, formsStore, 'MMM D')

mainFormPresenter.on('form-submit', formData =>
	handleCalendarFormSubmit({ partnerType, formData })
)
sideFormPresenter.on('form-submit', formData =>
	handleCalendarFormSubmit({ partnerType, formData })
)
